/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export enum AppStatusEnum {
	Unknown = "Unknown",
	NotDeployed = "NotDeployed",
	Stopped = "Stopped",
	Deploying = "Deploying",
	Initializing = "Initializing",
	Running = "Running",
	Terminating = "Terminating",
	Failing = "Failing",
	Crashing = "Crashing"
}

export interface paths {
	"/api/v1/account": {
		/** No permissions are required. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Account"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		put: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Account"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["AccountUpdateRqstV1"];
				};
			};
		};
		/** No permissions are required. */
		delete: {
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/account/stats": {
		/** No permissions are required. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ResourceCountRespV1"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/account/sso": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["SsoProfileSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		post: {
			parameters: {
				query: {
					type: components["schemas"]["SsoTypes"];
				};
			};
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["SsoProfile"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/account/sso/id/{ssoId}": {
		/** No permissions are required. */
		delete: {
			parameters: {
				path: {
					ssoId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/sign/up": {
		/** No permissions are required. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["User"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["UserCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/sign/in": {
		/** No permissions are required. */
		post: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserSnippet"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["Credentials"];
				};
			};
		};
	};
	"/api/v1/sign/resend-confirmation": {
		/** No permissions are required. */
		get: {
			responses: {
				/** No Content */
				204: never;
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/sign/confirm": {
		/** No permissions are required. */
		put: {
			responses: {
				/** No Content */
				204: never;
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["ConfirmationRqstV1"];
				};
			};
		};
	};
	"/api/v1/sign/password/forgot": {
		/** No permissions are required. */
		post: {
			responses: {
				/** No Content */
				204: never;
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["ForgotPasswordRqst"];
				};
			};
		};
	};
	"/api/v1/sign/password/reset": {
		/** No permissions are required. */
		post: {
			responses: {
				/** No Content */
				204: never;
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["ResetPasswordRqst"];
				};
			};
		};
	};
	"/api/v1/admin/accounts": {
		/** Required permissions: ADMIN/USER_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		post: {
			responses: {
				/** Created */
				201: unknown;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["InvitationRqstV1"];
				};
			};
		};
	};
	"/api/v1/admin/accounts/admins": {
		/** Required permissions: ADMIN/READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserWithRoleCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/admin/accounts/id/{accountId}": {
		/** Required permissions: ADMIN/USER_READ. */
		get: {
			parameters: {
				path: {
					accountId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountWithRole"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		put: {
			parameters: {
				path: {
					accountId: string;
				};
				query: {
					roleId?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountWithRole"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		delete: {
			parameters: {
				path: {
					accountId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/admin/accounts/id/{accountId}/sso": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					accountId: string;
				};
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["SsoProfileSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		post: {
			parameters: {
				path: {
					accountId: string;
				};
				query: {
					type: components["schemas"]["SsoTypes"];
				};
			};
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["SsoProfile"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/admin/accounts/id/{accountId}/sso/id/{ssoId}": {
		/** No permissions are required. */
		delete: {
			parameters: {
				path: {
					accountId: string;
					ssoId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/accounts": {
		/** Required permissions: APP/USERS_READ. */
		get: {
			parameters: {
				query: {
					includeOrgAdmins?: boolean;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserWithRoleCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/USERS_MANAGE. */
		post: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["InvitationRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/accounts/impersonate": {
		/** Required permissions: APP/END_USER. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserWithRoleCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/accounts/id/{accountId}": {
		/** Required permissions: APP/USERS_READ. */
		get: {
			parameters: {
				path: {
					accountId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountWithRole"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/USERS_MANAGE. */
		put: {
			parameters: {
				path: {
					accountId: string;
					/** Application ID. */
					appId: string;
				};
				query: {
					roleId?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountWithRole"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/USERS_MANAGE. */
		delete: {
			parameters: {
				path: {
					accountId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/blueprints": {
		/** Required permissions: APP/EDITOR_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["BlueprintSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/EDITOR_EDIT. */
		post: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Blueprint"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["BlueprintAddRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/blueprints/move": {
		/** Required permissions: APP/EDITOR_EDIT. */
		put: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: unknown;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["BlueprintMoveRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/blueprints/id/{blpId}": {
		/** Required permissions: APP/EDITOR_READ. */
		get: {
			parameters: {
				path: {
					blpId: string;
					/** Application ID. */
					appId: string;
				};
				query: {
					/** If version is null, the last blueprint is returned. */
					version?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Blueprint"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/EDITOR_EDIT. */
		put: {
			parameters: {
				path: {
					blpId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Blueprint"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["BlueprintAddRqstV1"];
				};
			};
		};
		/** Required permissions: APP/EDITOR_EDIT. */
		delete: {
			parameters: {
				path: {
					blpId: string;
					/** Application ID. */
					appId: string;
				};
				query: {
					/** If it is null, the last blueprint is returned. */
					version?: string;
				};
			};
			responses: {
				/** Success */
				200: unknown;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/blueprints/id/{blpId}/history": {
		/** Required permissions: APP/EDITOR_READ. */
		get: {
			parameters: {
				path: {
					blpId: string;
					/** Application ID. */
					appId: string;
				};
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["BlueprintSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/blueprints/id/{blpId}/version/{ver}": {
		/** Required permissions: APP/EDITOR_EDIT. */
		put: {
			parameters: {
				path: {
					blpId: string;
					ver: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Blueprint"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["BlueprintAddRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/blueprints/id/{blpId}/restore": {
		/** Required permissions: APP/EDITOR_EDIT. */
		put: {
			parameters: {
				path: {
					blpId: string;
					/** Application ID. */
					appId: string;
				};
				query: {
					version?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Blueprint"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/deployments": {
		/** Required permissions: APP/EDITOR_READ. */
		get: {
			parameters: {
				query: {
					appEnvId?: string;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["DeploymentCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/deployments/id/{dplId}": {
		/** Required permissions: APP/EDITOR_READ. */
		get: {
			parameters: {
				path: {
					dplId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Deployment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}/accounts/id/{accountId}/metadata": {
		/** Required permissions: APP/UM_READ. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
					/** Account ID. */
					accountId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountAppMetadata"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/UM_USERS_MANAGE. */
		put: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
					/** Account ID. */
					accountId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountAppMetadata"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["AccountAppDataUpdateRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}/deploy": {
		/** Required permissions: APP/DEPLOYMENT. */
		get: {
			parameters: {
				query: {
					tailLines?: number;
				};
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": string;
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/DEPLOYMENT. */
		put: {
			parameters: {
				query: {
					replicas: number;
				};
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/DEPLOYMENT. */
		post: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Deployment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["DeploymentRqstV1"];
				};
			};
		};
		/** Required permissions: APP/DEPLOYMENT. */
		delete: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}/deploy/awake": {
		/** Required permissions: APP/MANAGE. */
		post: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ServiceInfo"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments": {
		/** Required permissions: APP/READ. */
		get: {
			parameters: {
				query: {
					withEditorEnv?: boolean;
					withStatus?: boolean;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AppEnvironmentSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/MANAGE. */
		post: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["AppEnvironment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["AppEnvCrateRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/available": {
		/** Required permissions: APP/READ. */
		get: {
			parameters: {
				query: {
					name: string;
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AvailableRespV1"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/url": {
		/** Required permissions: APP/READ. */
		get: {
			parameters: {
				query: {
					url: string;
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UrlValidRespV1"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/editor": {
		/** Required permissions: APP/EDITOR_READ. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["EditorEnvironment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}": {
		/** Required permissions: APP/MANAGE. */
		get: {
			parameters: {
				path: {
					appEnvId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AppEnvironment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/MANAGE. */
		put: {
			parameters: {
				path: {
					appEnvId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AppEnvironment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["AppEnvUpdateRqstV1"];
				};
			};
		};
		/** Required permissions: APP/MANAGE. */
		delete: {
			parameters: {
				path: {
					appEnvId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}/login/check": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}/login/status": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AppEnvPublicSnippet"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}/metadata": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Metadata"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/HAE_SERVICE. */
		put: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Metadata"];
					};
				};
			};
			/** Metadata. */
			requestBody: {
				content: {
					"application/json": components["schemas"]["Metadata"];
				};
			};
		};
		/** Required permissions: ADMIN/HAE_SERVICE. */
		delete: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
			};
		};
	};
	"/api/v1/apps/id/{appId}/environments/id/{appEnvId}/metadata/{key}": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		put: {
			parameters: {
				path: {
					/** Key. */
					key: string;
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Metadata"];
					};
				};
			};
			/** Metadata for the key. */
			requestBody: {
				content: {
					"application/json": components["schemas"]["Metadata"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/invitations": {
		/** Required permissions: APP/USERS_READ. */
		get: {
			parameters: {
				query: {
					includeOrgInvitations?: boolean;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["InvitationCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/USERS_MANAGE. */
		post: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["InvitationRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/invitations/id/{invId}": {
		/** Required permissions: APP/USERS_READ. */
		get: {
			parameters: {
				path: {
					invId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Invitation"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/USERS_MANAGE. */
		put: {
			parameters: {
				path: {
					invId: string;
					/** Application ID. */
					appId: string;
				};
				query: {
					roleId?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Invitation"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/USERS_MANAGE. */
		delete: {
			parameters: {
				path: {
					invId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					orgId?: string;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ApplicationSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/APP_CREATE. */
		post: {
			parameters: {
				query: {
					orgId: string;
				};
			};
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["Application"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["AppCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/available": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					orgId: string;
					name: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AvailableRespV1"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}": {
		/** Required permissions: APP/READ. */
		get: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Application"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/MANAGE. */
		put: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Application"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["AppUpdateRqstV1"];
				};
			};
		};
		/** Required permissions: APP/MANAGE. */
		delete: {
			parameters: {
				path: {
					appId: string;
				};
				query: {
					hardDelete?: boolean;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/detail": {
		/** Required permissions: APP/DETAIL_READ. */
		get: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Application"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/stats": {
		/** Required permissions: APP/DETAIL_READ. */
		get: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ApplicationStatsDtoRespV1"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/image": {
		/** Required permissions: APP/MANAGE. */
		put: {
			parameters: {
				path: {
					appId: string;
				};
				query: {
					imageId?: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/appEnvs/id/{appEnvId}/login/check": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/appEnvs/id/{appEnvId}/login/status": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AppEnvPublicSnippet"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/metadata": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Metadata"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/HAE_SERVICE. */
		put: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Metadata"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["Metadata"];
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/roles": {
		/** Required permissions: APP/USERS_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["RoleSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/roles/id/{roleId}": {
		/** Required permissions: APP/USERS_READ. */
		get: {
			parameters: {
				path: {
					roleId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Role"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/subscriptions": {
		/** Required permissions: APP/MANAGE. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["SubscriptionCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/MANAGE. */
		post: {
			parameters: {
				query: {
					tariffId?: string;
					yearPayment?: boolean;
				};
				path: {
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Subscription"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/subscriptions/id/{subscriptionId}": {
		/** Required permissions: APP/MANAGE. */
		delete: {
			parameters: {
				path: {
					subscriptionId: string;
					/** Application ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Subscription"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/templates": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ApplicationSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/templates/public": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ApplicationSnippetCollection"];
					};
				};
			};
		};
	};
	"/api/v1/editors": {
		/** Required permissions: ADMIN/INFRA_READ. */
		get: {
			parameters: {
				query: {
					withStatus?: boolean;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AdminAppEnvironmentSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/email/newsletter": {
		/** Required permissions: ADMIN/USER_MANAGE. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountSnippet"][];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		post: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["CountResp"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["EmailCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/environments": {
		/** Required permissions: ADMIN/INFRA_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["CloudEnvironmentCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/INFRA_MANAGE. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["CloudEnvironment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["EnvCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/environments/{appId}": {
		/** Required permissions: APP/MANAGE. */
		get: {
			parameters: {
				path: {
					appId: string;
				};
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["CloudEnvironmentCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/environments/id/{envId}": {
		/** Required permissions: ADMIN/INFRA_READ. */
		get: {
			parameters: {
				path: {
					envId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["CloudEnvironment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/INFRA_MANAGE. */
		put: {
			parameters: {
				path: {
					envId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["CloudEnvironment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["EnvCreateRqstV1"];
				};
			};
		};
		/** Required permissions: ADMIN/INFRA_MANAGE. */
		delete: {
			parameters: {
				path: {
					envId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/token": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			parameters: {
				query: {
					invitationToken?: string;
					rememberMe?: boolean;
				};
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
				/** Bad Request */
				400: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Conflict */
				409: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["SsoProfileRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/token/admin": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			parameters: {
				query: {
					invitationToken?: string;
					rememberMe?: boolean;
				};
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
				/** Bad Request */
				400: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Conflict */
				409: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["SsoProfileRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/token/impersonate": {
		/** Required permissions: APP/EDITOR_READ. */
		post: {
			parameters: {
				query: {
					targetAppId?: string;
					targetAppEnvId?: string;
					targetAccountId?: string;
				};
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
				/** Bad Request */
				400: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/token/end-user": {
		/** No permissions are required. */
		post: {
			parameters: {
				query: {
					targetAppId?: string;
					targetAppEnvId?: string;
				};
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
				/** Bad Request */
				400: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/token/renew": {
		/** Required permissions: APP/END_USER. */
		get: {
			parameters: {
				query: {
					/** Expiration time [sec]. */
					expiration?: number;
				};
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/account/{accountId}": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		get: {
			parameters: {
				path: {
					accountId: string;
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountAppMetadata"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/account": {
		/** Required permissions: APP/END_USER. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountAppMetadata"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: APP/END_USER. */
		put: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountAppMetadata"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["AccountAppDataUpdateRqstV1"];
				};
			};
		};
	};
	"/api/v1/apps/{appId}/appEnvs/{appEnvId}/hae/login/check": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					/** Application ID. */
					appId: string;
					/** Application environment ID. */
					appEnvId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/images": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ImageCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/INFRA_MANAGE. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["Image"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["ImageCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/images/preview": {
		/** No permissions are required. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Image"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/images/latest": {
		/** No permissions are required. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Image"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/images/id/{imgId}": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					imgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Image"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		put: {
			parameters: {
				path: {
					imgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Image"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["ImageCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/likes": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["LikeCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/likes/app/{appId}": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					appId: string;
				};
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["LikeCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		put: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Like"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["LikeRqstV1"];
				};
			};
		};
		/** No permissions are required. */
		post: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["Like"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["LikeRqstV1"];
				};
			};
		};
		/** No permissions are required. */
		delete: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/likes/app/{appId}/my-like": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Like"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/likes/id/{likeId}": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					likeId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Like"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/notifications": {
		/** Required permissions: ADMIN/USER_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["NotificationCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["Notification"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["NotifRqstV1"];
				};
			};
		};
	};
	"/api/v1/notifications/id/{notificationId}": {
		/** Required permissions: ADMIN/USER_READ. */
		get: {
			parameters: {
				path: {
					notificationId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Notification"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		put: {
			parameters: {
				path: {
					notificationId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Notification"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["NotifRqstV1"];
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		delete: {
			parameters: {
				path: {
					notificationId: string;
				};
			};
			responses: {
				/** Success */
				200: unknown;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/notifications/my": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountNotificationCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		put: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["CountResp"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/notifications/my/unread-count": {
		/** No permissions are required. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountNotificationCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/notifications/id/{notificationId}/my": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					notificationId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountNotification"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/accounts": {
		/** Required permissions: ORG/USERS_READ. */
		get: {
			parameters: {
				query: {
					includeAppUsers?: boolean;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserWithRoleCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		post: {
			parameters: {
				path: {
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Created */
				201: unknown;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["InvitationRqstV1"];
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/accounts/id/{accountId}": {
		/** Required permissions: ORG/USERS_READ. */
		get: {
			parameters: {
				path: {
					accountId: string;
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountWithRole"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		put: {
			parameters: {
				path: {
					accountId: string;
					/** Organization ID. */
					orgId: string;
				};
				query: {
					roleId?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AccountWithRole"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		delete: {
			parameters: {
				path: {
					accountId: string;
					/** Organization ID. */
					orgId: string;
				};
				query: {
					deleteInApps?: boolean;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/orgs": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["OrganizationSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["Organization"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["OrgCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/orgs/available": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					name: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["AvailableRespV1"];
					};
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}": {
		/** Required permissions: ORG/READ. */
		get: {
			parameters: {
				path: {
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Organization"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/MANAGE. */
		put: {
			parameters: {
				path: {
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Organization"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["OrgCreateRqstV1"];
				};
			};
		};
		/** Required permissions: ORG/MANAGE. */
		delete: {
			parameters: {
				path: {
					orgId: string;
				};
				query: {
					hardDelete?: boolean;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/detail": {
		/** Required permissions: ORG/DETAIL_READ. */
		get: {
			parameters: {
				path: {
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Organization"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/billing": {
		/** Required permissions: ORG/BILLING_READ. */
		post: {
			parameters: {
				path: {
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Redirect"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/invitations": {
		/** Required permissions: ORG/USERS_READ. */
		get: {
			parameters: {
				query: {
					includeAppsInvitations?: boolean;
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["InvitationCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		post: {
			parameters: {
				path: {
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["InvitationRqstV1"];
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/invitations/id/{invId}": {
		/** Required permissions: ORG/USERS_READ. */
		get: {
			parameters: {
				path: {
					invId: string;
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Invitation"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		put: {
			parameters: {
				path: {
					invId: string;
					/** Organization ID. */
					orgId: string;
				};
				query: {
					roleId?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Invitation"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		delete: {
			parameters: {
				path: {
					invId: string;
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/payments": {
		/** Required permissions: APP/SUBSCRIPTION_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Organization ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["PaymentSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/apps/id/{appId}/payments/id/{paymentId}": {
		/** Required permissions: APP/SUBSCRIPTION_READ. */
		get: {
			parameters: {
				path: {
					paymentId: string;
					/** Organization ID. */
					appId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Payment"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/roles": {
		/** Required permissions: ORG/USERS_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
				path: {
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["RoleSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		post: {
			parameters: {
				path: {
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Created */
				201: unknown;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["RoleCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/orgs/id/{orgId}/roles/id/{roleId}": {
		/** Required permissions: ORG/USERS_READ. */
		get: {
			parameters: {
				path: {
					roleId: string;
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Role"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		put: {
			parameters: {
				path: {
					roleId: string;
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Role"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["Role"];
				};
			};
		};
		/** Required permissions: ORG/USERS_MANAGE. */
		delete: {
			parameters: {
				path: {
					roleId: string;
					/** Organization ID. */
					orgId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/profile": {
		/** No permissions are required. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserProfile"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		put: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserProfile"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["UserUpdateRqstV1"];
				};
			};
		};
		/** No permissions are required. */
		delete: {
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/profile/password": {
		/** No permissions are required. */
		put: {
			responses: {
				/** Success */
				200: unknown;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["ChangeProfilePasswordRqst"];
				};
			};
		};
	};
	"/api/v1/registration": {
		/** No permissions are required. */
		post: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Application"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["RegCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/roles": {
		/** Required permissions: ADMIN/READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["RoleSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/ROLE_MANAGE. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["Role"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["Role"];
				};
			};
		};
	};
	"/api/v1/roles/id/{roleId}": {
		/** Required permissions: ADMIN/READ. */
		get: {
			parameters: {
				path: {
					roleId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Role"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/ROLE_MANAGE. */
		put: {
			parameters: {
				path: {
					roleId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Role"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["Role"];
				};
			};
		};
		/** Required permissions: ADMIN/ROLE_MANAGE. */
		delete: {
			parameters: {
				path: {
					roleId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/security/token": {
		/** No permissions are required. */
		get: {
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** No permissions are required. */
		post: {
			parameters: {
				query: {
					/** The number of times a token can be used. */
					usage?: number;
					/** Expiration time [sec]. */
					expiration?: number;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/security/token/verify": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					token?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": boolean;
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/service/pod/awake": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			parameters: {
				query: {
					url?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["ServiceInfo"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/service/migrate/subscription": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			responses: {
				/** No Content */
				204: never;
			};
		};
	};
	"/api/v1/service/update/roles-permissions": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			responses: {
				/** No Content */
				204: never;
			};
		};
	};
	"/api/v1/service/test/{appId}": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		get: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
			};
		};
	};
	"/api/v1/stats": {
		/** Required permissions: ADMIN/READ. */
		get: {
			parameters: {
				query: {
					timeFrom?: string;
					timeTo?: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Statistics"][];
					};
				};
			};
		};
	};
	"/api/v1/stripe/webhook": {
		/** No permissions are required. */
		post: {
			responses: {
				/** No Content */
				204: never;
				/** Bad Request */
				400: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/tariffs": {
		/** No permissions are required. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["TariffSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/TARIFF_MANAGE. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["Tariff"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["TariffCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/tariffs/id/{tariffId}": {
		/** No permissions are required. */
		get: {
			parameters: {
				path: {
					tariffId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["Tariff"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/TARIFF_MANAGE. */
		delete: {
			parameters: {
				path: {
					tariffId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/users": {
		/** Required permissions: ADMIN/USER_READ. */
		get: {
			parameters: {
				query: {
					limit?: number;
					offset?: number;
					withCount?: boolean;
					filters?: { [key: string]: string }[];
					sorts?: { [key: string]: string }[];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["UserSnippetCollection"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		post: {
			responses: {
				/** Created */
				201: {
					content: {
						"application/json": components["schemas"]["User"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["UserCreateRqstV1"];
				};
			};
		};
	};
	"/api/v1/users/id/{userId}": {
		/** Required permissions: ADMIN/USER_READ. */
		get: {
			parameters: {
				path: {
					userId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["User"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		put: {
			parameters: {
				path: {
					userId: string;
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["User"];
					};
				};
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["UserUpdateRqstV1"];
				};
			};
		};
		/** Required permissions: ADMIN/USER_MANAGE. */
		delete: {
			parameters: {
				path: {
					userId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
		};
	};
	"/api/v1/users/id/{userId}/password": {
		/** Required permissions: ADMIN/USER_MANAGE. */
		put: {
			parameters: {
				path: {
					userId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
				/** Unauthorized */
				401: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Forbidden */
				403: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
				/** Not Found */
				404: {
					content: {
						"application/json": components["schemas"]["ProblemDetails"];
					};
				};
			};
			requestBody: {
				content: {
					"application/json": components["schemas"]["PasswordRqstV1"];
				};
			};
		};
	};
	"/api/v1/vault/app/{appId}/reset-vault": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
			};
		};
	};
	"/api/v1/vault/app/{appId}/env/{appEnvId}/vault/app-policy": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			parameters: {
				path: {
					appId: string;
					appEnvId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
			};
		};
	};
	"/api/v1/vault/app/{appId}/vault/editor-policy": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			parameters: {
				path: {
					appId: string;
				};
			};
			responses: {
				/** No Content */
				204: never;
			};
		};
	};
	"/api/v1/vault/app/{appId}/env/{appEnvId}/vault/token": {
		/** Required permissions: ADMIN/HAE_SERVICE. */
		post: {
			parameters: {
				path: {
					appId: string;
					appEnvId: string;
				};
				query: {
					policy?: components["schemas"]["Policy"];
				};
			};
			responses: {
				/** Success */
				200: {
					content: {
						"application/json": components["schemas"]["JwtToken"];
					};
				};
			};
		};
	};
}

export interface components {
	schemas: {
		Account: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Account ID.
			 */
			accountId?: string;
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/** @description Photo (URL). */
			photo?: string | null;
			/** @description Enabled. */
			enabled: boolean;
			/** @description If user agreed with terms and conditions. */
			terms: boolean;
			/** @description If user agreed with GDPR. */
			gdpr: boolean;
			/** @description Get full name. */
			fullName?: string | null;
			/** @description Sso types. */
			ssoTypes?: string[] | null;
			/** @description Timezone. */
			timezone?: string | null;
			language?: components["schemas"]["Language"];
			/** @description Country. */
			country?: string | null;
			/**
			 * Format: tel
			 * @description Phone.
			 */
			phone?: string | null;
			/** @description If user agreed with sending newsletters. */
			newsletters?: boolean;
		};
		AccountAppDataUpdateRqstV1: {
			/** @description Language. */
			language?: string | null;
			/** @description Timezone. */
			timezone?: string | null;
			/** @description Metadata. */
			data?: unknown | null;
		};
		AccountAppMetadata: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Account ID.
			 */
			accountId?: string;
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/** @description Photo (URL). */
			photo?: string | null;
			/** @description Enabled. */
			enabled: boolean;
			/** @description If user agreed with terms and conditions. */
			terms: boolean;
			/** @description If user agreed with GDPR. */
			gdpr: boolean;
			/** @description Get full name. */
			fullName?: string | null;
			/** @description Sso types. */
			ssoTypes?: string[] | null;
			/** @description Timezone. */
			timezone?: string | null;
			language?: components["schemas"]["Language"];
			/** @description Country. */
			country?: string | null;
			/**
			 * Format: tel
			 * @description Phone.
			 */
			phone?: string | null;
			/** @description If user agreed with sending newsletters. */
			newsletters?: boolean;
			/**
			 * Format: date-time
			 * @description Last time when user signed in.
			 */
			signedAt?: string | null;
			/** @description Is user logged as admin. */
			isAdmin?: boolean;
			/** @description Data. */
			data?: unknown | null;
		};
		AccountNotification: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Notification ID.
			 */
			notifId?: string;
			/** @description Title. */
			title?: string | null;
			/** @description Message. */
			message?: string | null;
			type?: components["schemas"]["NotificationTypes"];
			/**
			 * Format: date-time
			 * @description Date.
			 */
			date?: string;
			/**
			 * Format: date-time
			 * @description Read.
			 */
			read?: string | null;
		};
		AccountNotificationCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["AccountNotification"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		AccountRoleSnippet: {
			resource?: components["schemas"]["Resources"];
			/**
			 * Format: uuid
			 * @description Resource Id.
			 */
			resourceId?: string;
			/** @description Resource name. */
			resourceName?: string | null;
			/**
			 * Format: uuid
			 * @description Role Id.
			 */
			roleId: string;
			/** @description Role name. */
			roleName: string;
			/** @description If role is affected by another role. */
			affection: boolean;
		};
		AccountSnippet: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Account ID.
			 */
			accountId?: string;
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/** @description Photo (URL). */
			photo?: string | null;
			/** @description Enabled. */
			enabled: boolean;
			/** @description If user agreed with terms and conditions. */
			terms: boolean;
			/** @description If user agreed with GDPR. */
			gdpr: boolean;
			/** @description Get full name. */
			fullName?: string | null;
			/** @description Sso types. */
			ssoTypes?: string[] | null;
		};
		AccountSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["AccountSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		AccountUpdateRqstV1: {
			/** @description First name. */
			firstName?: string | null;
			/** @description Last name. */
			lastName?: string | null;
			/** @description Photo (URL). */
			photo?: string | null;
			/** @description Language. */
			language?: string | null;
			/** @description Timezone. */
			timezone?: string | null;
			/**
			 * Format: tel
			 * @description Phone.
			 */
			phone?: string | null;
			/** @description Country. */
			country?: string | null;
			/** @description If user agreed with terms and conditions. */
			terms?: boolean;
			/** @description If user agreed with GDPR. */
			gdpr?: boolean;
			/** @description If user agreed with sending newsletters. */
			newsletters?: boolean;
		};
		AccountWithRole: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Account ID.
			 */
			accountId?: string;
			/** @description Email. */
			email: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/** @description User's photo. */
			photo?: string | null;
			/**
			 * Format: date-time
			 * @description Last logged in.
			 */
			signedAt?: string | null;
			resource?: components["schemas"]["Resources"];
			/**
			 * Format: uuid
			 * @description Resource Id.
			 */
			resourceId: string;
			/** @description Resource name. */
			resourceName: string;
			/**
			 * Format: uuid
			 * @description Role Id.
			 */
			roleId: string;
			/** @description Role name. */
			roleName: string;
			/** @description Enabled. */
			enabled: boolean;
			/** @description Is end user. */
			endUser: boolean;
			/** @description Roles. */
			roles?: components["schemas"]["AccountRoleSnippet"][] | null;
		};
		AdminAppEnvironmentSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["InternalAppEnvironment"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		AppCreateRqstV1: {
			/** @description Application name. */
			name: string;
			/** @description Description. */
			description?: string | null;
			/** @description Icon. */
			icon?: string | null;
			/**
			 * Format: uri
			 * @description Application image URL.
			 */
			appImage?: string | null;
			/** @description Starred application. */
			starred?: boolean;
			/** @description Is app template. */
			isTemplate?: boolean;
			/** @description Is app template public. */
			isPublicTemplate?: boolean;
			/** @description Email white list. */
			emailsWhiteList?: string[] | null;
			imageUpdateStrategy?: components["schemas"]["ImageUpdateStrategy"];
			/**
			 * @description Template.<br />
			 * Posible values:
			 * <list type="table"><listheader><term>Value</term><term>Variable</term><description>Description</description></listheader><item><term>null</term><term>X</term><description>no template used at all</description></item><item><term>X</term><term>templateId</term><description>created from template app</description></item><item><term>__default__</term><term>X</term><description>created from template TemplateOrg/DefaultTemplate</description></item><item><term>X</term><term>name</term><description>created from template TemplateOrg/name</description></item></list>
			 */
			template?: string | null;
		};
		AppEnvCrateRqstV1: {
			/** @description Application environment name. */
			name?: string | null;
			/** @description URL address. */
			url?: string | null;
			/** @description Is environment protected. */
			isProtected?: boolean;
			/** @description Environment variables. */
			envVars?: components["schemas"]["EnvVar"][] | null;
			/**
			 * Format: uuid
			 * @description Environment ID.
			 */
			envId: string;
		};
		AppEnvPublicSnippet: {
			/** @description App environment name. */
			name?: string | null;
			/** @description Application name. */
			appName?: string | null;
			/** @description Is editor. */
			isEditor?: boolean;
			/** @description Enabled. */
			enabled?: boolean;
			status?: components["schemas"]["AppStatus"];
			/** @description Application URL (back compatibility). */
			appUrl?: string | null;
			/** @description Application URL. */
			url?: string | null;
			certificate?: components["schemas"]["Certificates"];
			/** @description Is environment protected. */
			isProtected?: boolean;
			/** @description Is DNS and TXT record checked. */
			isDnsChecked?: boolean;
			/**
			 * Format: int32
			 * @description Restart count.
			 */
			restartCount?: number;
			/** @description Is an application environment stopped. */
			stopped?: boolean;
			/** @description Is an application environment idle. */
			idle?: boolean;
		};
		AppEnvUpdateRqstV1: {
			/** @description Application environment name. */
			name?: string | null;
			/** @description URL address. */
			url?: string | null;
			/** @description Is environment protected. */
			isProtected?: boolean;
			/** @description Environment variables. */
			envVars?: components["schemas"]["EnvVar"][] | null;
		};
		AppEnvironment: {
			/** @description App environment name. */
			name?: string | null;
			/** @description Application name. */
			appName?: string | null;
			/** @description Is editor. */
			isEditor?: boolean;
			/** @description Enabled. */
			enabled?: boolean;
			status?: components["schemas"]["AppStatus"];
			/** @description Application URL (back compatibility). */
			appUrl?: string | null;
			/** @description Application URL. */
			url?: string | null;
			certificate?: components["schemas"]["Certificates"];
			/** @description Is environment protected. */
			isProtected?: boolean;
			/** @description Is DNS and TXT record checked. */
			isDnsChecked?: boolean;
			/**
			 * Format: int32
			 * @description Restart count.
			 */
			restartCount?: number;
			/** @description Is an application environment stopped. */
			stopped?: boolean;
			/** @description Is an application environment idle. */
			idle?: boolean;
			/**
			 * Format: uuid
			 * @description AppEnv ID.
			 */
			appEnvId?: string;
			/** @description Environment name. */
			environmentName?: string | null;
			/** @description Current deployed version. */
			currentVersion?: string | null;
			/**
			 * Format: date-time
			 * @description Last modified.
			 */
			lastModified?: string | null;
			/**
			 * Format: date-time
			 * @description Pod start time.
			 */
			startTime?: string | null;
			/** @description Pod start time. */
			runningTime?: string | null;
			/** @description Used image name. */
			image?: string | null;
			/**
			 * Format: uuid
			 * @description Used image ID.
			 */
			imageId?: string;
			/** @description Pod name. */
			podName?: string | null;
			/** @description Name of kubernetes resources (deployment, service, ingress). */
			resourceName?: string | null;
			/** @description Worker API URL. */
			workerApiUrl?: string | null;
			/** @description Environment variables. */
			envVars?: components["schemas"]["EnvVar"][] | null;
		};
		AppEnvironmentSnippet: {
			/** @description App environment name. */
			name?: string | null;
			/** @description Application name. */
			appName?: string | null;
			/** @description Is editor. */
			isEditor?: boolean;
			/** @description Enabled. */
			enabled?: boolean;
			status?: components["schemas"]["AppStatus"];
			/** @description Application URL (back compatibility). */
			appUrl?: string | null;
			/** @description Application URL. */
			url?: string | null;
			certificate?: components["schemas"]["Certificates"];
			/** @description Is environment protected. */
			isProtected?: boolean;
			/** @description Is DNS and TXT record checked. */
			isDnsChecked?: boolean;
			/**
			 * Format: int32
			 * @description Restart count.
			 */
			restartCount?: number;
			/** @description Is an application environment stopped. */
			stopped?: boolean;
			/** @description Is an application environment idle. */
			idle?: boolean;
			/**
			 * Format: uuid
			 * @description AppEnv ID.
			 */
			appEnvId?: string;
			/** @description Environment name. */
			environmentName?: string | null;
			/** @description Current deployed version. */
			currentVersion?: string | null;
			/**
			 * Format: date-time
			 * @description Last modified.
			 */
			lastModified?: string | null;
			/**
			 * Format: date-time
			 * @description Pod start time.
			 */
			startTime?: string | null;
			/** @description Pod start time. */
			runningTime?: string | null;
			/** @description Used image name. */
			image?: string | null;
			/**
			 * Format: uuid
			 * @description Used image ID.
			 */
			imageId?: string;
		};
		AppEnvironmentSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["AppEnvironmentSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		/** @enum {string} */
		AppStatus: AppStatusEnum
		AppUpdateRqstV1: {
			/** @description Application name. */
			name: string;
			/** @description Description. */
			description?: string | null;
			/** @description Icon. */
			icon?: string | null;
			/**
			 * Format: uri
			 * @description Application image URL.
			 */
			appImage?: string | null;
			/** @description Starred application. */
			starred?: boolean;
			/** @description Is app template. */
			isTemplate?: boolean;
			/** @description Is app template public. */
			isPublicTemplate?: boolean;
			/** @description Email white list. */
			emailsWhiteList?: string[] | null;
			imageUpdateStrategy?: components["schemas"]["ImageUpdateStrategy"];
		};
		Application: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Application ID.
			 */
			appId?: string;
			/**
			 * Format: uuid
			 * @description Organization ID.
			 */
			orgId?: string;
			/** @description Organization name. */
			orgName?: string | null;
			/** @description Application name. */
			name?: string | null;
			/** @description Description. */
			description?: string | null;
			/** @description Icon. */
			icon?: string | null;
			/** @description Application image URL. */
			appImage?: string | null;
			/** @description If an application is starred. */
			starred?: boolean;
			/** @description Is an application a template. */
			isTemplate?: boolean;
			/** @description Is an application a public template. */
			isPublicTemplate?: boolean;
			imageUpdateStrategy?: components["schemas"]["ImageUpdateStrategy"];
			/** @description If an application is enabled. */
			enabled?: boolean;
			/**
			 * Format: date-time
			 * @description Recent activity.
			 */
			recentActivity?: string;
			/**
			 * Format: date-time
			 * @description Released date.
			 */
			releasedDate?: string | null;
			/**
			 * Format: int32
			 * @description The number of application forked (from its template).
			 */
			forksCount?: number;
			/**
			 * Format: int32
			 * @description The number of likes.
			 */
			likesCount?: number;
			/** @description Have I liked the app? */
			myLike?: boolean;
			subscription?: components["schemas"]["Subscription"];
			pendingSubscription?: components["schemas"]["Subscription"];
			/** @description Git organization. */
			gitOrganization?: string | null;
			/** @description Git repository. */
			gitRepository?: string | null;
			/** @description Editor URL. */
			editorUrl?: string | null;
			/** @description Worker URL. */
			workerApiUrl?: string | null;
			/** @description Sandbox URL. */
			sandboxUrl?: string | null;
			/** @description AppEngine image ID of new version. */
			newImageAvailable?: boolean;
			/**
			 * Format: uuid
			 * @description AppEngine image ID.
			 */
			newImgId?: string;
			/** @description Image name and version. */
			newImageName?: string | null;
			/**
			 * Format: uuid
			 * @description AppEngine image ID.
			 */
			imgId?: string;
			/** @description Image name and version. */
			imageName?: string | null;
			/** @description Application slug. */
			slug?: string | null;
			/** @description Organization slug. */
			orgSlug?: string | null;
			/** @description Email white list. */
			emailWhiteList?: string[] | null;
			/** @description Name of template used in this app. */
			basedOnTemplate?: string | null;
			/**
			 * Format: int32
			 * @description The number of application environments.
			 */
			appEnvsCount?: number;
			/**
			 * Format: int32
			 * @description The number of developers.
			 */
			developersCount?: number;
			/**
			 * Format: int32
			 * @description The number of end users.
			 */
			endUsersCount?: number;
		};
		ApplicationSnippet: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Application ID.
			 */
			appId?: string;
			/**
			 * Format: uuid
			 * @description Organization ID.
			 */
			orgId?: string;
			/** @description Organization name. */
			orgName?: string | null;
			/** @description Application name. */
			name?: string | null;
			/** @description Description. */
			description?: string | null;
			/** @description Icon. */
			icon?: string | null;
			/** @description Application image URL. */
			appImage?: string | null;
			/** @description If an application is starred. */
			starred?: boolean;
			/** @description Is an application a template. */
			isTemplate?: boolean;
			/** @description Is an application a public template. */
			isPublicTemplate?: boolean;
			imageUpdateStrategy?: components["schemas"]["ImageUpdateStrategy"];
			/** @description If an application is enabled. */
			enabled?: boolean;
			/**
			 * Format: date-time
			 * @description Recent activity.
			 */
			recentActivity?: string;
			/**
			 * Format: date-time
			 * @description Released date.
			 */
			releasedDate?: string | null;
			/**
			 * Format: int32
			 * @description The number of application forked (from its template).
			 */
			forksCount?: number;
			/**
			 * Format: int32
			 * @description The number of likes.
			 */
			likesCount?: number;
			/** @description Have I liked the app? */
			myLike?: boolean;
			subscription?: components["schemas"]["Subscription"];
			pendingSubscription?: components["schemas"]["Subscription"];
		};
		ApplicationSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["ApplicationSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		ApplicationStatsDtoRespV1: {
			authors?: components["schemas"]["Author"][] | null;
			/** Format: int64 */
			revisionsCount?: number;
			/** Format: int64 */
			deploymentsCount?: number;
		};
		Author: {
			name?: string | null;
			/** Format: double */
			spentTimeHr?: number;
		};
		AvailableRespV1: {
			/** @description Available */
			available: boolean;
		};
		Blueprint: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			deleted?: string | null;
			/** @description User which has deleted the entity. */
			deletedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Blueprint ID.
			 */
			id?: string;
			/** @description Blueprint path. */
			path?: string | null;
			/** @description Doc type. */
			docType?: string | null;
			/** @description Label. */
			label?: string | null;
			/**
			 * Format: date-time
			 * @description Last blueprint version.
			 */
			lastVersion?: string;
			/** @description Description. */
			description?: string | null;
			/** @description Allow read. If not, the blueprint is hiden */
			allowRead?: boolean;
			/** @description Allow write. */
			allowWrite?: boolean;
			/** @description Allow rename. */
			allowRename?: boolean;
			/** @description Allow remove. */
			allowRemove?: boolean;
			/** @description Content. */
			content?: string | null;
			/**
			 * Format: int32
			 * @description Size of history.
			 */
			historySize?: number;
			/** @description Content. */
			allRefToThisBlueprint?: components["schemas"]["BlueprintInfo"][] | null;
		};
		BlueprintAddRqstV1: {
			/** @description Blueprint path. */
			path: string;
			/** @description Doc type. */
			docType: string;
			/** @description Label. */
			label: string;
			/** @description Description. */
			description?: string | null;
			/** @description Allow read. If not, the blueprint is hiden */
			allowRead?: boolean;
			/** @description Allow write. */
			allowWrite?: boolean;
			/** @description Allow rename. */
			allowRename?: boolean;
			/** @description Allow remove. */
			allowRemove?: boolean;
			/** @description Content. */
			content: string;
		};
		BlueprintInfo: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			deleted?: string | null;
			/** @description User which has deleted the entity. */
			deletedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Blueprint ID.
			 */
			id?: string;
			/** @description Blueprint path. */
			path?: string | null;
			/** @description Doc type. */
			docType?: string | null;
			/** @description Label. */
			label?: string | null;
			/**
			 * Format: date-time
			 * @description Last blueprint version.
			 */
			lastVersion?: string;
		};
		BlueprintMoveRqstV1: {
			/** @description New blueprint path. */
			path: string;
			/** @description Blueprint IDs. */
			blueprintIds: string[];
		};
		BlueprintSnippet: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			deleted?: string | null;
			/** @description User which has deleted the entity. */
			deletedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Blueprint ID.
			 */
			id?: string;
			/** @description Blueprint path. */
			path?: string | null;
			/** @description Doc type. */
			docType?: string | null;
			/** @description Label. */
			label?: string | null;
			/**
			 * Format: date-time
			 * @description Last blueprint version.
			 */
			lastVersion?: string;
			/** @description Description. */
			description?: string | null;
			/** @description Allow read. If not, the blueprint is hiden */
			allowRead?: boolean;
			/** @description Allow write. */
			allowWrite?: boolean;
			/** @description Allow rename. */
			allowRename?: boolean;
			/** @description Allow remove. */
			allowRemove?: boolean;
		};
		BlueprintSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["BlueprintSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		/** @enum {string} */
		Certificates: "Unknown" | "LetsEncrypt" | "Sectigo" | "Custom";
		ChangeProfilePasswordRqst: {
			/** @description Old password. */
			oldPassword: string;
			/** @description New password. */
			newPassword: string;
		};
		CloudEnvironment: {
			/**
			 * Format: uuid
			 * @description Environment ID.
			 */
			envId?: string;
			/** @description Environment name. */
			name: string;
			/** @description Is environment public. */
			isPublic: boolean;
			/** @description Is environment protected by default. */
			isDefaultProtected?: boolean;
			/**
			 * Format: int32
			 * @description Number of uses.
			 */
			numOfUses?: number;
		};
		CloudEnvironmentCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["CloudEnvironment"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		ConfirmationRqstV1: {
			/** @description Verfication code. */
			verificationCode: string;
			/** @description Confirmation token */
			confirmationToken: string;
		};
		CountResp: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
		};
		Credentials: {
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
			/** @description Password. */
			password: string;
		};
		/** @enum {string} */
		Currency: "Czk" | "Eur" | "Usd";
		Deployment: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Deployment ID.
			 */
			deploymentId?: string;
			/** @description Application URL (back compatibility). */
			appUrl?: string | null;
			/** @description Application URL. */
			url?: string | null;
			/** @description App Engine image. */
			appEngineImage?: string | null;
			/** @description App Engine image. */
			repositoryUrl?: string | null;
			/** @description Application version. */
			version?: string | null;
			/** @description Application environment name. */
			appEnvironmentName?: string | null;
			status?: components["schemas"]["DeploymentStatus"];
			/** @description Error message. */
			errorMessage?: string | null;
		};
		DeploymentCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["Deployment"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		DeploymentRqstV1: {
			/** @description Version. */
			version: string;
			/**
			 * Format: int32
			 * @description The number of views.
			 */
			numberOfViews?: number;
			/**
			 * Format: int32
			 * @description The number of integrations.
			 */
			numberOfIntegrations?: number;
			/**
			 * Format: int32
			 * @description The number of actions.
			 */
			numberOfActions?: number;
		};
		/** @enum {string} */
		DeploymentStatus: "Success" | "Failure";
		EditorEnvironment: {
			/** @description App environment name. */
			name?: string | null;
			/** @description Application name. */
			appName?: string | null;
			/** @description Is editor. */
			isEditor?: boolean;
			/** @description Enabled. */
			enabled?: boolean;
			status?: components["schemas"]["AppStatus"];
			/** @description Application URL (back compatibility). */
			appUrl?: string | null;
			/** @description Application URL. */
			url?: string | null;
			certificate?: components["schemas"]["Certificates"];
			/** @description Is environment protected. */
			isProtected?: boolean;
			/** @description Is DNS and TXT record checked. */
			isDnsChecked?: boolean;
			/**
			 * Format: int32
			 * @description Restart count.
			 */
			restartCount?: number;
			/** @description Is an application environment stopped. */
			stopped?: boolean;
			/** @description Is an application environment idle. */
			idle?: boolean;
			/**
			 * Format: uuid
			 * @description AppEnv ID.
			 */
			appEnvId?: string;
			/** @description Environment name. */
			environmentName?: string | null;
			/** @description Current deployed version. */
			currentVersion?: string | null;
			/**
			 * Format: date-time
			 * @description Last modified.
			 */
			lastModified?: string | null;
			/**
			 * Format: date-time
			 * @description Pod start time.
			 */
			startTime?: string | null;
			/** @description Pod start time. */
			runningTime?: string | null;
			/** @description Used image name. */
			image?: string | null;
			/**
			 * Format: uuid
			 * @description Used image ID.
			 */
			imageId?: string;
			/** @description Pod name. */
			podName?: string | null;
			/** @description Name of kubernetes resources (deployment, service, ingress). */
			resourceName?: string | null;
			/** @description Worker API URL. */
			workerApiUrl?: string | null;
			/** @description Environment variables. */
			envVars?: components["schemas"]["EnvVar"][] | null;
			/** @description Sandbox URL. */
			sandboxUrl?: string | null;
			/** @description Editor URL. */
			editorUrl?: string | null;
		};
		EmailCreateRqstV1: {
			/** @description From who the email was sent. */
			emailFrom?: string | null;
			/** @description Email's subject. */
			subject: string;
			/** @description HTML email body. */
			htmlBody?: string | null;
			/** @description Text email body. */
			textBody: string;
		};
		/** @enum {string} */
		Emoji: "Like" | "Heart";
		EnvCreateRqstV1: {
			/** @description Environment name. */
			name: string;
			/** @description Namespace in kubernetes. */
			namespace: string;
			/** @description Is environment public. */
			isPublic: boolean;
			/** @description Kube config. */
			kubeConfig: string;
		};
		EnvVar: {
			/** @description Environment variable. */
			variable: string;
			/** @description Value. */
			value: string;
		};
		ForgotPasswordRqst: {
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
		};
		Image: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Image ID.
			 */
			imgId?: string;
			/** @description Image name. */
			name: string;
			/** @description Version. */
			version: string;
			/** @description Note. */
			note?: string | null;
			/** @description URL to registry with image. */
			applicationImageUrl: string;
			/** @description URL to registry with image. */
			editorImageUrl: string;
			/** @description URL to registry with image. */
			sandboxImageUrl: string;
			/** @description URL to registry with image. */
			workerImageUrl: string;
			/** @description Is image preview. */
			isPreview: boolean;
			/** @description Is image latest. */
			isLatest: boolean;
			/** @description Is image public. */
			isPublic: boolean;
			/**
			 * Format: int32
			 * @description Number of uses.
			 */
			numOfUses?: number;
		};
		ImageCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["Image"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		ImageCreateRqstV1: {
			/** @description Image name. */
			name: string;
			/** @description Version. */
			version: string;
			/** @description Note. */
			note?: string | null;
			/** @description URL to registry with app image. */
			applicationImageUrl: string;
			/** @description URL to registry with editor image. */
			editorImageUrl: string;
			/** @description URL to registry with sandbox image. */
			sandboxImageUrl?: string | null;
			/** @description URL to registry with worker image. */
			workerImageUrl: string;
			/** @description Is image public. */
			isPublic: boolean;
			/** @description Is image preview. */
			isPreview?: boolean;
			/** @description Is image latest. */
			isLatest?: boolean;
		};
		/** @enum {string} */
		ImageUpdateStrategy: "NoUpdate" | "Latest" | "Preview";
		InternalAppEnvironment: {
			/** @description App environment name. */
			name?: string | null;
			/** @description Application name. */
			appName?: string | null;
			/** @description Is editor. */
			isEditor?: boolean;
			/** @description Enabled. */
			enabled?: boolean;
			status?: components["schemas"]["AppStatus"];
			/** @description Application URL (back compatibility). */
			appUrl?: string | null;
			/** @description Application URL. */
			url?: string | null;
			certificate?: components["schemas"]["Certificates"];
			/** @description Is environment protected. */
			isProtected?: boolean;
			/** @description Is DNS and TXT record checked. */
			isDnsChecked?: boolean;
			/**
			 * Format: int32
			 * @description Restart count.
			 */
			restartCount?: number;
			/** @description Is an application environment stopped. */
			stopped?: boolean;
			/** @description Is an application environment idle. */
			idle?: boolean;
			/**
			 * Format: uuid
			 * @description AppEnv ID.
			 */
			appEnvId?: string;
			/** @description Environment name. */
			environmentName?: string | null;
			/** @description Current deployed version. */
			currentVersion?: string | null;
			/**
			 * Format: date-time
			 * @description Last modified.
			 */
			lastModified?: string | null;
			/**
			 * Format: date-time
			 * @description Pod start time.
			 */
			startTime?: string | null;
			/** @description Pod start time. */
			runningTime?: string | null;
			/** @description Used image name. */
			image?: string | null;
			/**
			 * Format: uuid
			 * @description Used image ID.
			 */
			imageId?: string;
			/** @description Pod name. */
			podName?: string | null;
			/** @description Name of kubernetes resources (deployment, service, ingress). */
			resourceName?: string | null;
			/** @description Worker API URL. */
			workerApiUrl?: string | null;
			/** @description Environment variables. */
			envVars?: components["schemas"]["EnvVar"][] | null;
			/** @description Sandbox URL. */
			sandboxUrl?: string | null;
			/** @description Editor URL. */
			editorUrl?: string | null;
			/**
			 * Format: uuid
			 * @description Application ID.
			 */
			appId?: string;
		};
		Invitation: {
			/**
			 * Format: uuid
			 * @description Invitation ID.
			 */
			invId?: string;
			/** @description Status. */
			email?: string | null;
			/**
			 * Format: uuid
			 * @description Role ID.
			 */
			roleId?: string;
			/** @description Role name. */
			roleName?: string | null;
			/**
			 * Format: date-time
			 * @description Time of invitation.
			 */
			invited?: string;
			/** @description Invited by. */
			invitedBy?: string | null;
			resource?: components["schemas"]["Resources"];
			/**
			 * Format: uuid
			 * @description Resource Id.
			 */
			resourceId?: string;
			/** @description Resource name. */
			resourceName?: string | null;
			/** @description Is end user. */
			endUser?: boolean;
		};
		InvitationCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["Invitation"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		InvitationRqstV1: {
			/**
			 * Format: uuid
			 * @description App environment ID.
			 */
			appEnvId?: string | null;
			/**
			 * Format: email
			 * @description Status.
			 */
			email: string;
			/**
			 * Format: uuid
			 * @description Role ID.
			 */
			roleId: string;
		};
		JwtToken: {
			/** @description JWT token. */
			token?: string | null;
		};
		/**
		 * @description User UI language
		 * @enum {string}
		 */
		Language: "En" | "Cs";
		Like: {
			/**
			 * Format: uuid
			 * @description Like ID.
			 */
			like_id?: string;
			/**
			 * Format: uuid
			 * @description Application name.
			 */
			accountId?: string;
			/**
			 * Format: uuid
			 * @description Number of users.
			 */
			appId?: string;
			/** @description Account name. */
			accountName?: string | null;
			/** @description Application name. */
			appName?: string | null;
			emoji?: components["schemas"]["Emoji"];
		};
		LikeCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["Like"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		LikeRqstV1: {
			emoji: components["schemas"]["Emoji"];
		};
		Metadata: {
			/** @description Data. */
			data?: unknown | null;
		};
		NotifRqstV1: {
			/** @description Title. */
			title?: string | null;
			/** @description Message. */
			message?: string | null;
			type?: components["schemas"]["NotificationTypes"];
			/**
			 * Format: date-time
			 * @description Date.
			 */
			date?: string | null;
		};
		Notification: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Notification ID.
			 */
			notifId?: string;
			/** @description Title. */
			title?: string | null;
			/** @description Message. */
			message?: string | null;
			type?: components["schemas"]["NotificationTypes"];
			/**
			 * Format: date-time
			 * @description Date.
			 */
			date?: string;
			/**
			 * Format: int32
			 * @description The number of accounts who read the notification.
			 */
			readCount?: number;
		};
		NotificationCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["Notification"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		/** @enum {string} */
		NotificationTypes: "News" | "Alert";
		OrgCreateRqstV1: {
			/** @description Organization name. */
			name: string;
			/** @description Starred organization. */
			starred?: boolean;
			/**
			 * Format: uri
			 * @description Website
			 */
			website?: string | null;
			/**
			 * Format: uri
			 * @description URL to company logo.
			 */
			logoUrl?: string | null;
		};
		Organization: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Organization ID.
			 */
			orgId?: string;
			/** @description Starred organization. */
			starred: boolean;
			/**
			 * Format: date-time
			 * @description Recent activity.
			 */
			recentActivity?: string;
			/** @description Organization name. */
			name: string;
			/**
			 * Format: uri
			 * @description Website
			 */
			website?: string | null;
			/**
			 * Format: uri
			 * @description URL to company logo.
			 */
			logoUrl?: string | null;
			/** @description If the organization is enabled. */
			enabled: boolean;
			/**
			 * Format: int32
			 * @description Number of application in organization.
			 */
			appsCount?: number;
			/** @description Organization slug. */
			slug?: string | null;
			/** @description Stripe customer ID. */
			hasStripeAccount?: boolean;
			/** @description Git organization. */
			gitOrganization?: string | null;
			/** @description Billing email. */
			billingEmail?: string | null;
			/** @description Billing phone. */
			billingPhone?: string | null;
			/** @description Address - street. */
			addressStreet?: string | null;
			/** @description Address - city. */
			addressCity?: string | null;
			/** @description Address - city zip code. */
			addressZipCode?: string | null;
			/** @description Address - country. */
			addressCountry?: string | null;
			/** @description Address - state. */
			addressState?: string | null;
			/** @description Legal company ID. */
			companyId?: string | null;
			/** @description VAT ID. */
			vatId?: string | null;
		};
		OrganizationSnippet: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/** @description List of permissions. */
			permissions?: string[] | null;
			/**
			 * Format: uuid
			 * @description Organization ID.
			 */
			orgId?: string;
			/** @description Starred organization. */
			starred: boolean;
			/**
			 * Format: date-time
			 * @description Recent activity.
			 */
			recentActivity?: string;
			/** @description Organization name. */
			name: string;
			/**
			 * Format: uri
			 * @description Website
			 */
			website?: string | null;
			/**
			 * Format: uri
			 * @description URL to company logo.
			 */
			logoUrl?: string | null;
			/** @description If the organization is enabled. */
			enabled: boolean;
			/**
			 * Format: int32
			 * @description Number of application in organization.
			 */
			appsCount?: number;
		};
		OrganizationSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["OrganizationSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		PasswordRqstV1: {
			/** @description Password. */
			password: string;
		};
		Payment: {
			/**
			 * Format: uuid
			 * @description Payment ID.
			 */
			paymentId?: string;
			/**
			 * Format: date-time
			 * @description Issue date.
			 */
			issueDate?: string;
			/**
			 * Format: date-time
			 * @description Date of payment.
			 */
			paidDate?: string | null;
			/**
			 * Format: date-time
			 * @description Issue date.
			 */
			periodFrom?: string;
			/**
			 * Format: date-time
			 * @description Issue date.
			 */
			periodTo?: string;
			/**
			 * Format: float
			 * @description Total price.
			 */
			price?: number;
			/** @description Invoice link. */
			invoiceLink?: string | null;
		};
		PaymentSnippet: {
			/**
			 * Format: uuid
			 * @description Payment ID.
			 */
			paymentId?: string;
			/**
			 * Format: date-time
			 * @description Issue date.
			 */
			issueDate?: string;
			/**
			 * Format: date-time
			 * @description Date of payment.
			 */
			paidDate?: string | null;
			/**
			 * Format: date-time
			 * @description Issue date.
			 */
			periodFrom?: string;
			/**
			 * Format: date-time
			 * @description Issue date.
			 */
			periodTo?: string;
			/**
			 * Format: float
			 * @description Total price.
			 */
			price?: number;
			/** @description Invoice link. */
			invoiceLink?: string | null;
		};
		PaymentSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["PaymentSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		/** @enum {string} */
		Policy: "Application" | "Editor";
		ProblemDetails: {
			type?: string | null;
			title?: string | null;
			/** Format: int32 */
			status?: number | null;
			detail?: string | null;
			instance?: string | null;
		} & { [key: string]: unknown };
		Redirect: {
			redirectUrl?: string | null;
		};
		RegCreateRqstV1: {
			org: components["schemas"]["OrgCreateRqstV1"];
			app: components["schemas"]["AppCreateRqstV1"];
		};
		ResetPasswordRqst: {
			/** @description Reset token for reqest validation. */
			resetToken: string;
			/** @description New password. */
			password: string;
		};
		ResourceCountRespV1: {
			/**
			 * Format: int32
			 * @description Worker image.
			 */
			ownOrgsCount: number;
			/**
			 * Format: int32
			 * @description Editor image.
			 */
			ownAppsCount: number;
		};
		/** @enum {string} */
		Resources: "Organization" | "Application" | "Admin";
		Role: {
			/**
			 * Format: uuid
			 * @description Role ID.
			 */
			roleId?: string;
			/** @description Role name. */
			name?: string | null;
			/** @description If role is publicly accessed. */
			isPublic?: boolean;
			/** @description Permissions. */
			permissions?: string[] | null;
		};
		RoleCreateRqstV1: {
			/** @description Role name. */
			name?: string | null;
			/** @description Permissions. */
			permissions?: string[] | null;
		};
		RoleSnippet: {
			/**
			 * Format: uuid
			 * @description Role ID.
			 */
			roleId?: string;
			/** @description Role name. */
			name?: string | null;
			/** @description If role is publicly accessed. */
			isPublic?: boolean;
		};
		RoleSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["RoleSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		ServiceInfo: {
			/** @description App environment name. */
			name?: string | null;
			/** @description Application name. */
			appName?: string | null;
			/** @description Is editor. */
			isEditor?: boolean;
			/** @description Enabled. */
			enabled?: boolean;
			status?: components["schemas"]["AppStatus"];
		};
		SsoProfile: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Sso profile ID.
			 */
			ssoId?: string;
			/** @description Unique ID for user recognition. */
			ssoProfileId?: string | null;
			ssoType?: components["schemas"]["SsoTypes"];
		};
		SsoProfileRqstV1: {
			/** @description Unique ID for user recognition. */
			ssoProfileId: string;
			ssoProfileType: components["schemas"]["SsoTypes"];
			/** @description Unique ID for user recognition. */
			email: string;
			/** @description Photo. */
			photo?: string | null;
			/** @description First name. */
			firstName?: string | null;
			/** @description Last name. */
			lastName?: string | null;
			/** @description Language. */
			language?: string | null;
			/** @description Timezone. */
			timezone?: string | null;
			/** @description Entire SSO data (for debugging purposes). */
			data?: unknown | null;
		};
		SsoProfileSnippet: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Sso profile ID.
			 */
			ssoId?: string;
			/** @description Unique ID for user recognition. */
			ssoProfileId?: string | null;
			ssoType?: components["schemas"]["SsoTypes"];
		};
		SsoProfileSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["SsoProfileSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		/** @enum {string} */
		SsoTypes: "Custom" | "Adapptio" | "Google" | "Linkedin";
		Statistics: {
			/**
			 * Format: date-time
			 * @description Time form the stat is generated.
			 */
			from?: string;
			/**
			 * Format: date-time
			 * @description Time to the stat is generated.
			 */
			to?: string;
			/**
			 * Format: int32
			 * @description Number of platform a active users.
			 */
			platformUsersCount?: number;
			/**
			 * Format: int32
			 * @description Number of active users in all applications.
			 */
			appUsersCount?: number;
			/**
			 * Format: int32
			 * @description Number of new users in platform.
			 */
			newUsersCount?: number;
			/**
			 * Format: int32
			 * @description Number of new organizations.
			 */
			newOrgsCount?: number;
			/**
			 * Format: int32
			 * @description Number of new applications.
			 */
			newAppsCount?: number;
			/**
			 * Format: int32
			 * @description Number of new released applications.
			 */
			newReleasedAppsCount?: number;
		};
		Subscription: {
			/**
			 * Format: date-time
			 * @description DateTime when the entity was created.
			 */
			created?: string;
			/** @description User which has created the entity. */
			createdBy?: string | null;
			/**
			 * Format: date-time
			 * @description DateTime when the entity was last modified.
			 */
			modified?: string;
			/** @description Use which has modified the entity last. */
			modifiedBy?: string | null;
			/**
			 * Format: uuid
			 * @description Subscription ID.
			 */
			subscriptionId?: string;
			/**
			 * Format: uuid
			 * @description App ID.
			 */
			appId?: string;
			/** @description Is active. */
			isActive?: boolean;
			/** @description Is pending. */
			isPending?: boolean;
			status?: components["schemas"]["SubscriptionStatus"];
			/**
			 * Format: date-time
			 * @description To when the subscription is valid.
			 */
			validTo?: string | null;
			/**
			 * Format: date-time
			 * @description When the subscription ended.
			 */
			ended?: string | null;
			/** @description Who ended subscription. */
			endedBy?: string | null;
			/** @description URL to checkout this subscription. */
			checkoutUrl?: string | null;
			tariff?: components["schemas"]["Tariff"];
		};
		SubscriptionCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["Subscription"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		/** @enum {string} */
		SubscriptionStatus:
		| "Unknown"
		| "Free"
		| "Trial"
		| "WaitingPayment"
		| "Paid"
		| "Unpaid"
		| "Canceled";
		Tariff: {
			/**
			 * Format: uuid
			 * @description Tariff ID.
			 */
			tariffId?: string;
			/** @description Name. */
			name?: string | null;
			/** @description Tariff description. */
			description?: string | null;
			/**
			 * Format: float
			 * @description Price.
			 */
			price?: number;
			/**
			 * Format: float
			 * @description Price.
			 */
			yearPrice?: number;
			currency?: components["schemas"]["Currency"];
			/**
			 * Format: int32
			 * @description Number of uses.
			 */
			numOfUses?: number;
			/**
			 * Format: int32
			 * @description CPU limit [mCPUs].
			 */
			cpuLimit?: number;
			/**
			 * Format: int32
			 * @description RAM limit [MB].
			 */
			ramLimit?: number;
			/**
			 * Format: int32
			 * @description Storage [MB].
			 */
			storage?: number;
			/**
			 * Format: int32
			 * @description Blueprint views limit.
			 */
			blueprintViewsLimit?: number;
			/**
			 * Format: int32
			 * @description Blueprint integrations limit.
			 */
			blueprintIntegrationsLimit?: number;
			/**
			 * Format: int32
			 * @description Users limit.
			 */
			usersLimit?: number;
			/**
			 * Format: int32
			 * @description Concurent users limit.
			 */
			concurentUsersLimit?: number;
			/**
			 * Format: int32
			 * @description Developers limit.
			 */
			developersLimit?: number;
			/** @description If tariff is public, so can be choosen. */
			isPublic?: boolean;
			/** @description If tariff is meant to be for released application. */
			isRelease?: boolean;
			/** @description Is default. */
			isDefault?: boolean;
			/** @description Has app hot start. */
			appHotStart?: boolean;
			/** @description Has editor hot start. */
			editorHotStart?: boolean;
			/** @description On premise. */
			onPremise?: boolean;
			/**
			 * Format: int32
			 * @description Tariff trial period in DAYS.
			 */
			trialPeriod?: number | null;
			/** @description Tariff permissions. */
			permissions?: string[] | null;
		};
		TariffCreateRqstV1: {
			/** @description Tariff name. */
			name: string;
			/** @description Tariff description. */
			description?: string | null;
			/**
			 * Format: float
			 * @description Price.
			 */
			price: number;
			/**
			 * Format: float
			 * @description Price.
			 */
			yearPrice?: number;
			currency?: components["schemas"]["Currency"];
			/**
			 * Format: int32
			 * @description CPU limit [CPUs].
			 */
			cpuLimit: number;
			/**
			 * Format: int32
			 * @description RAM limit [GB].
			 */
			ramLimit: number;
			/**
			 * Format: int32
			 * @description Storage [GB].
			 */
			storage: number;
			/** @description On premise. */
			onPremise?: boolean;
			/**
			 * Format: int32
			 * @description Blueprint views limit.
			 */
			blueprintViewsLimit?: number;
			/**
			 * Format: int32
			 * @description Blueprint integrations limit.
			 */
			blueprintIntegrationsLimit?: number;
			/**
			 * Format: int32
			 * @description Users limit.
			 */
			usersLimit?: number;
			/**
			 * Format: int32
			 * @description Concurent users limit.
			 */
			concurentUsersLimit?: number;
			/**
			 * Format: int32
			 * @description Developers limit.
			 */
			developersLimit?: number;
			/** @description Has app hot start. */
			appHotStart?: boolean;
			/** @description Has editor hot start. */
			editorHotStart?: boolean;
			/** @description If tariff is public, so can be choosen. */
			isPublic?: boolean;
			/** @description If tariff is meant to be for released application. */
			isRelease?: boolean;
			/** @description Is the tariff default. */
			isDefault?: boolean;
			/**
			 * Format: int32
			 * @description Tariff trial period in DAYS.
			 */
			trialPeriod?: number | null;
			/** @description Tariff permissions. */
			permissions?: string[] | null;
		};
		TariffSnippet: {
			/**
			 * Format: uuid
			 * @description Tariff ID.
			 */
			tariffId?: string;
			/** @description Name. */
			name?: string | null;
			/** @description Tariff description. */
			description?: string | null;
			/**
			 * Format: float
			 * @description Price.
			 */
			price?: number;
			/**
			 * Format: float
			 * @description Price.
			 */
			yearPrice?: number;
			currency?: components["schemas"]["Currency"];
			/**
			 * Format: int32
			 * @description Number of uses.
			 */
			numOfUses?: number;
			/**
			 * Format: int32
			 * @description CPU limit [mCPUs].
			 */
			cpuLimit?: number;
			/**
			 * Format: int32
			 * @description RAM limit [MB].
			 */
			ramLimit?: number;
			/**
			 * Format: int32
			 * @description Storage [MB].
			 */
			storage?: number;
			/**
			 * Format: int32
			 * @description Blueprint views limit.
			 */
			blueprintViewsLimit?: number;
			/**
			 * Format: int32
			 * @description Blueprint integrations limit.
			 */
			blueprintIntegrationsLimit?: number;
			/**
			 * Format: int32
			 * @description Users limit.
			 */
			usersLimit?: number;
			/**
			 * Format: int32
			 * @description Concurent users limit.
			 */
			concurentUsersLimit?: number;
			/**
			 * Format: int32
			 * @description Developers limit.
			 */
			developersLimit?: number;
			/** @description If tariff is public, so can be choosen. */
			isPublic?: boolean;
			/** @description If tariff is meant to be for released application. */
			isRelease?: boolean;
			/** @description Is default. */
			isDefault?: boolean;
			/** @description Has app hot start. */
			appHotStart?: boolean;
			/** @description Has editor hot start. */
			editorHotStart?: boolean;
			/** @description On premise. */
			onPremise?: boolean;
			/**
			 * Format: int32
			 * @description Tariff trial period in DAYS.
			 */
			trialPeriod?: number | null;
		};
		TariffSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["TariffSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		UrlValidRespV1: {
			/** @description Is URL available. */
			isUrlAvailable: boolean;
			/** @description Is URL valid. */
			isUrlValid: boolean;
			/** @description Is DNS ok. */
			isDnsValid: boolean;
			/** @description Is internal. */
			isInternal: boolean;
			/** @description Valid URL. */
			validUrl?: string | null;
			certificate?: components["schemas"]["Certificates"];
		};
		User: {
			/**
			 * Format: uuid
			 * @description User ID.
			 */
			userId?: string;
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/** @description Photo. */
			photo?: string | null;
			/** @description If the user is confirmed. */
			confirmed?: boolean;
			/** @description Enabled. */
			enabled: boolean;
			/**
			 * Format: tel
			 * @description Phone.
			 */
			phone?: string | null;
			/** @description Country. */
			country?: string | null;
			language?: components["schemas"]["Language"];
			/**
			 * Format: date-time
			 * @description Datetime of last successful login.
			 */
			loginLast?: string | null;
			/**
			 * Format: int32
			 * @description Number of unsuccessful login attempts.
			 */
			loginAttempts?: number;
		};
		UserCreateRqstV1: {
			/** @description Password. */
			password: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/**
			 * Format: tel
			 * @description Phone.
			 */
			phone?: string | null;
			/** @description Photo (URL). */
			photo?: string | null;
			/** @description Country. */
			country?: string | null;
			/** @description Time zone. */
			timezone?: string | null;
			language?: components["schemas"]["Language"];
			/** @description If user agreed with sending newsletters. */
			newsletters: boolean;
			/** @description If user agreed with terms and conditions. */
			termsAndConditions: boolean;
			/** @description If user agreed with GDPR. */
			gdpr: boolean;
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
		};
		UserProfile: {
			/**
			 * Format: uuid
			 * @description User ID.
			 */
			userId?: string;
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/** @description Photo. */
			photo?: string | null;
			/** @description If the user is confirmed. */
			confirmed?: boolean;
			/** @description Enabled. */
			enabled: boolean;
			/**
			 * Format: tel
			 * @description Phone.
			 */
			phone?: string | null;
			/** @description Country. */
			country?: string | null;
			language?: components["schemas"]["Language"];
			/**
			 * Format: date-time
			 * @description Datetime of last successful login.
			 */
			loginLast?: string | null;
			/**
			 * Format: int32
			 * @description Number of unsuccessful login attempts.
			 */
			loginAttempts?: number;
		};
		UserSnippet: {
			/**
			 * Format: uuid
			 * @description User ID.
			 */
			userId?: string;
			/**
			 * Format: email
			 * @description Email.
			 */
			email: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/** @description Photo. */
			photo?: string | null;
			/** @description If the user is confirmed. */
			confirmed?: boolean;
			/** @description Enabled. */
			enabled: boolean;
		};
		UserSnippetCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["UserSnippet"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
		UserUpdateRqstV1: {
			/** @description Password. */
			password: string;
			/** @description First name. */
			firstName: string;
			/** @description Last name. */
			lastName: string;
			/**
			 * Format: tel
			 * @description Phone.
			 */
			phone?: string | null;
			/** @description Photo (URL). */
			photo?: string | null;
			/** @description Country. */
			country?: string | null;
			/** @description Time zone. */
			timezone?: string | null;
			language?: components["schemas"]["Language"];
			/** @description If user agreed with sending newsletters. */
			newsletters: boolean;
			/** @description If user agreed with terms and conditions. */
			termsAndConditions: boolean;
			/** @description If user agreed with GDPR. */
			gdpr: boolean;
		};
		UserWithRoleCollection: {
			/**
			 * Format: int64
			 * @description Count.
			 */
			count: number;
			/** @description Items. */
			items: components["schemas"]["AccountWithRole"][];
			/**
			 * Format: int64
			 * @description Items limitaion.
			 */
			limit: number;
			/**
			 * Format: int64
			 * @description Offset.
			 */
			offset: number;
		};
	};
}

export interface operations { }

export interface external { }
